var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoffin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M406.537 115.25L298.765 9.375C292.639 3.375 284.262 0 275.635 0H172.365C163.738 0 155.361 3.375 149.235 9.375L41.463 115.25C33.461 123.125 30.211 134.625 32.961 145.625L120.104 487.75C123.73 502 136.732 512 151.735 512H296.39C311.268 512 324.27 502 327.896 487.75L415.039 145.625C417.789 134.625 414.539 123.125 406.537 115.25ZM284.512 464H163.488L81.846 142.875L178.491 48H269.509L366.154 142.875L284.512 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffin);
export default __webpack_public_path__ + "static/media/coffin.d5a4e4ea66ba86db0144adc5d16d68df.svg";
export { ForwardRef as ReactComponent };